import { CameraState } from '../../../@types/redux/store/CameraTypes';

const initialState: CameraState = {
  images: [],
  carCheckImages: {},
};

export default initialState;
